import type { Agent } from '@/domain/types';
import { STUDIO_IDS } from '@/data/studios';

export const AGENTS: Record<string, Agent> = {
  georgina: {
    id: 'georgina',
    firstName: 'Georgina',
    lastName: 'Gray',
    role: 'operations-lead',
    // Network-wide: derived from the studio map so it tracks the real 11 studios.
    assignedStudios: [...STUDIO_IDS],
    avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&q=70',
    shiftHours: { start: '08:00', end: '18:00' },
  },
  'agent-lydia': {
    id: 'agent-lydia',
    firstName: 'Lydia',
    lastName: 'Tran',
    role: 'bookings-agent',
    assignedStudios: ['coburg'],
    primaryStudio: 'coburg',
    avatarUrl: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=160&q=70',
    shiftHours: { start: '09:00', end: '17:00' },
  },
  'agent-cameron': {
    id: 'agent-cameron',
    firstName: 'Cameron',
    lastName: 'Wells',
    role: 'bookings-agent',
    assignedStudios: ['coburg', 'collingwood', 'frankston'],
    primaryStudio: 'coburg',
    avatarUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=160&q=70',
    shiftHours: { start: '10:00', end: '18:00' },
  },
  'agent-jordan': {
    id: 'agent-jordan',
    firstName: 'Jordan',
    lastName: 'Hayes',
    role: 'bookings-agent',
    assignedStudios: ['frankston', 'windsor'],
    primaryStudio: 'frankston',
    avatarUrl: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=160&q=70',
    shiftHours: { start: '10:00', end: '18:00' },
  },
  'agent-priya': {
    id: 'agent-priya',
    firstName: 'Priya',
    lastName: 'Reddy',
    role: 'bookings-agent',
    assignedStudios: ['central-coast', 'emu-plains', 'mackay', 'liverpool'],
    primaryStudio: 'central-coast',
    avatarUrl: 'https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=160&q=70',
    shiftHours: { start: '09:00', end: '17:00' },
  },
  'agent-malia': {
    id: 'agent-malia',
    firstName: 'Malia',
    lastName: 'Sefa',
    role: 'bookings-agent',
    assignedStudios: ['brisbane', 'gold-coast'],
    primaryStudio: 'brisbane',
    avatarUrl: 'https://images.unsplash.com/photo-1573497019418-b400bb3ab074?w=160&q=70',
    shiftHours: { start: '08:30', end: '16:30' },
  },
  'agent-rachel': {
    id: 'agent-rachel',
    firstName: 'Rachel',
    lastName: 'McKenzie',
    role: 'bookings-agent',
    assignedStudios: ['tasmania'],
    primaryStudio: 'tasmania',
    avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=160&q=70',
    shiftHours: { start: '09:00', end: '17:00' },
  },
  'mgr-coburg': {
    id: 'mgr-coburg',
    firstName: 'Eli',
    lastName: 'Marchetti',
    role: 'studio-manager',
    assignedStudios: ['coburg'],
    primaryStudio: 'coburg',
    avatarUrl: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=160&q=70',
  },
  'mgr-collingwood': {
    id: 'mgr-collingwood',
    firstName: 'Mia',
    lastName: 'Lawler',
    role: 'studio-manager',
    assignedStudios: ['collingwood'],
    primaryStudio: 'collingwood',
  },
  'mgr-frankston': {
    id: 'mgr-frankston',
    firstName: 'Sam',
    lastName: 'Whitlock',
    role: 'studio-manager',
    assignedStudios: ['frankston'],
    primaryStudio: 'frankston',
  },
  'mgr-windsor': {
    id: 'mgr-windsor',
    firstName: 'Andy',
    lastName: 'Pham',
    role: 'studio-manager',
    assignedStudios: ['windsor'],
    primaryStudio: 'windsor',
  },
  'mgr-central-coast': {
    id: 'mgr-central-coast',
    firstName: 'Marcus',
    lastName: 'Sullivan',
    role: 'studio-manager',
    assignedStudios: ['central-coast'],
    primaryStudio: 'central-coast',
  },
  'mgr-emu-plains': {
    id: 'mgr-emu-plains',
    firstName: 'Nina',
    lastName: 'Hassan',
    role: 'studio-manager',
    assignedStudios: ['emu-plains'],
    primaryStudio: 'emu-plains',
  },
  'mgr-mackay': {
    id: 'mgr-mackay',
    firstName: 'Theo',
    lastName: 'Becker',
    role: 'studio-manager',
    assignedStudios: ['mackay'],
    primaryStudio: 'mackay',
  },
  'mgr-liverpool': {
    id: 'mgr-liverpool',
    firstName: 'Kira',
    lastName: 'O\'Neil',
    role: 'studio-manager',
    assignedStudios: ['liverpool'],
    primaryStudio: 'liverpool',
  },
  'mgr-brisbane': {
    id: 'mgr-brisbane',
    firstName: 'Hugo',
    lastName: 'Park',
    role: 'studio-manager',
    assignedStudios: ['brisbane'],
    primaryStudio: 'brisbane',
  },
  'mgr-gold-coast': {
    id: 'mgr-gold-coast',
    firstName: 'Lila',
    lastName: 'Carter',
    role: 'studio-manager',
    assignedStudios: ['gold-coast'],
    primaryStudio: 'gold-coast',
  },
  'mgr-tasmania': {
    id: 'mgr-tasmania',
    firstName: 'Asher',
    lastName: 'Singh',
    role: 'studio-manager',
    assignedStudios: ['tasmania'],
    primaryStudio: 'tasmania',
  },
  // 75n6: the Ops sub-role seats (one person each). Their own roles keep them
  // out of "the studio manager" / "the Ops lead" lookups.
  'conf-rafael': {
    id: 'conf-rafael',
    firstName: 'Rafael',
    lastName: 'Ortiz',
    role: 'confirmations',
    assignedStudios: [...STUDIO_IDS],
    shiftHours: { start: '09:00', end: '17:00' },
  },
  'sweep-tama': {
    id: 'sweep-tama',
    firstName: 'Tama',
    lastName: 'Kemp',
    role: 'sweeper',
    assignedStudios: [...STUDIO_IDS],
    shiftHours: { start: '09:00', end: '17:00' },
  },
  'floor-noor': {
    id: 'floor-noor',
    firstName: 'Noor',
    lastName: 'Haddad',
    role: 'floor',
    assignedStudios: ['coburg'],
    primaryStudio: 'coburg',
    shiftHours: { start: '10:00', end: '18:00' },
  },
  owner: {
    id: 'owner',
    firstName: 'Jake',
    lastName: 'Boyer',
    role: 'owner',
    // Network-wide: derived from the studio map so it tracks the real 11 studios.
    assignedStudios: [...STUDIO_IDS],
  },
};
